import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InstallmentsSliderComponent } from '../installments-slider/installments-slider.component';
import { NgClass, NgIf } from '@angular/common';
import { ReactiveTypedFormsModule } from '@rxweb/reactive-form-validators';
import { BaseComponent } from '../base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EarlyRepaymentService } from '../../services/early-repayment.service';
import { ButtonLoaderDirective } from '../../directives/button-loader.directive';
import { InfoModalComponent } from '../../pages/early-repayment/components/info-modal/info-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MiscService } from '../../services/misc.service';
import { ProformaDownloadService } from '../../services/proforma-download.service';

@Component({
    selector: 'mobilize-early-repayment-contract',
    animations: [
        trigger('rotateChevron', [
            state('open', style({
                transform: 'rotate(180deg)'
            })),
            state('closed', style({
                transform: 'rotate(0deg)'
            })),
            transition('open <=> closed', [
                animate('0.3s ease-in-out')
            ]),
        ]),
        trigger('slideToggle', [
            state('open', style({
                height: '*',
                opacity: 1,
                overflow: 'hidden'
            })),
            state('closed', style({
                height: '0px',
                minHeight: '0px',
                padding: 0,
                opacity: 0,
                overflow: 'hidden'
            })),
            transition('open <=> closed', [
                animate('0.4s ease-in-out')
            ]),
        ]),
    ],
    imports: [
        InstallmentsSliderComponent,
        NgIf,
        ReactiveTypedFormsModule,
        ButtonLoaderDirective,
        NgClass,
        MatTooltip,
        MatProgressSpinner
    ],
    templateUrl: './early-repayment-contract.component.html',
    styleUrl: './early-repayment-contract.component.scss'
})
export class EarlyRepaymentContractComponent extends BaseComponent implements OnInit {
    private _snackbar = inject(MatSnackBar);
    private _dialog = inject(MatDialog);
    private _earlyRepayment = inject(EarlyRepaymentService);
    private _misc = inject(MiscService);
    private _proformaDownload = inject(ProformaDownloadService);

    @Input() contract: any;
    @Input() firstContract: any;
    @Input() selectedContract: any;
    @Input() selectedPaymentMethod: any;
    @Output() onPay = new EventEmitter();
    @Output() onFullReimbursement = new EventEmitter();
    @Output() onPartialReimbursement = new EventEmitter();
    @Output() notifyParent: EventEmitter<any> = new EventEmitter();
    @Output() onHistoryTab = new EventEmitter();

    showPartial = true;

    extendContract = false;
    monthsRemaining: any;
    showEarlyRepaymentOptions = true;
    totalFullReimbursement = 0;
    calculatingRates = false;
    paymentPhase = false;
    fullReimbursementData: any;
    partialReimbursementData: any;
    finalExchangeRate: any;
    totalAmountLoaded = false;
    allowPeriodReduction: boolean = false;
    fullReimbursementActive = false;
    newMonthlyRate: any;
    currentStep = 1;
    isProcessing = false;
    snackErrorRef: any;
    noReimbursement = false;
    noBilledInstallment = false;
    choice = '';
    steps: { index: number; state: 'active' | 'inactive' | 'passed' }[] = [
        {
            index: 1,
            state: 'inactive'
        },
        {
            index: 2,
            state: 'inactive'
        },
        {
            index: 3,
            state: 'inactive'
        }
    ];

    ngOnInit() {
        if (this.selectedContract) {
            if (this.selectedContract.contract.contract_id === this.contract.contract_id) {
                this.toggleContractState();
            }
        } else {
            if (this.firstContract) {
                this.toggleContractState()
            }
        }

        this.showEarlyRepaymentOptions = !this.contract.proforma_invoices.some((item: any) => item.contract_change?.status === 'pending');
    }

    toggleContractState(autoClose?: boolean) {
        if (autoClose) {
            this.extendContract = false;
            this.contract.state = 'collapsed';
            return;
        }
        this.extendContract = !this.extendContract;
        if (this.extendContract) {
            if (this.contract.contract_number === '40271660') {
                this.showPartial = true;
            }
            this.contract.state = 'extended';
            this.notifyParent.emit({closeOtherContracts: true, selected: this.contract});
            this.totalAmountLoaded = false;

            if (this.contract.proforma_invoices.length === 0 || this.showEarlyRepaymentOptions) {
                if (!this.contract.previous_instalments || this.contract.previous_instalments < 1) {
                    this.noBilledInstallment = true;
                    this.noReimbursement = true;
                    this.totalAmountLoaded = true;
                    return;
                }

                this._misc.exchange().subscribe(rsp => {
                    this.finalExchangeRate = (parseFloat(rsp.exchangeRate) + parseFloat((rsp.exchangeRate * this.contract.fx_markup / 100).toString())).toFixed(4);
                });
                this._earlyRepayment.fullReimbursement({contract_id: this.contract.contract_id}).subscribe(rsp => {
                    if (!rsp.success) {
                        this._snackbar.open(rsp.message, 'Ok', {
                            duration: 5000,
                            panelClass: 'error-snack'
                        });
                        this.noReimbursement = true;
                        this.noBilledInstallment = rsp.reason === 'NO_BILLED_INSTALLMENT';
                        this.totalAmountLoaded = true;
                        return;
                    }
                    this.fullReimbursementData = rsp;
                    this.totalFullReimbursement = rsp.grand_total.faraTva;
                    this.totalAmountLoaded = true;
                });
            }
        } else {
            this.contract.state = 'collapsed';
        }
    }

    get bulletStateClass(): string[] {
        return this.steps.map(step => {
            if (step.index === this.currentStep) {
                return 'active';
            } else if (step.index < this.currentStep) {
                return 'passed';
            } else {
                return 'inactive';
            }
        });
    }

    finalizePayment(contract: any) {
        console.log(contract)
        this.onPay.next({contract, partialReimbursementData: this.partialReimbursementData, finalExchangeRate: this.finalExchangeRate})
    }

    openInfo() {
        this._dialog.open(InfoModalComponent, {
            width: '470px'
        })
    }

    previousStep() {
        this.currentStep--;
        this.currentStep--;
    }

    nextStep(contract: any, option: string = 'installment') {
        this.contract = contract;

        if (option) {
            this.choice = option;
        }

        this.currentStep++
        switch (this.currentStep) {
            case 1:
                if (!contract.amount) {
                    this.snackErrorRef = this._snackbar.open('Introdu suma pe care vrei sa o achiti', 'Ok', {
                        verticalPosition: 'top',
                        panelClass: 'snack-error',
                        duration: 5000
                    });
                    return;
                } else {
                    this.currentStep++;
                    if (this.snackErrorRef) {
                        this.snackErrorRef.dismiss();
                    }
                }
                break;

            case 2:
                this.isProcessing = true;
                const payload: any = {};
                if (option === 'installment') {
                    payload.paymentAdvance = contract.amount;
                    payload.contract_id = contract.contract_id;
                    payload.reducePeriod = false;
                    this._earlyRepayment.calculate(payload).subscribe(rsp => {
                        if (rsp.success) {
                            this.currentStep++;
                            this.newMonthlyRate = rsp.newMonthlyRateNet.gross;
                            this.monthsRemaining = rsp.monthsRemaining;
                            this.isProcessing = false;
                            this.calculatingRates = false;
                            this.partialReimbursementData = rsp;
                        } else {
                            this._snackbar.open(rsp.error, 'Ok', {
                                duration: 5000,
                                panelClass: 'error-snack'
                            });
                            this.currentStep = 1;
                        }
                    })
                } else {
                    this._earlyRepayment.calculateInstallments({contract_id: contract.contract_id}).subscribe(rsp => {
                        this.calculateRemainingRates();
                    });
                }
                break;
        }
    }

    calculateRemainingRates() {
        const payload: any = {};
        payload.paymentAdvance = this.contract.amount;
        payload.contract_id = this.contract.contract_id;
        payload.reducePeriod = true;

        this._earlyRepayment.calculate(payload).subscribe(rsp => {
            console.log(rsp)
            if (rsp.success) {
                this.currentStep++
                this.newMonthlyRate = rsp.newMonthlyRateNet;
                this.monthsRemaining = rsp.monthsRemaining;

                this.isProcessing = false;
                this.calculatingRates = false;
            } else {
                this._snackbar.open(rsp.error, 'Ok', {
                    duration: 5000,
                    panelClass: 'error-snack'
                });
                this.currentStep = 1;
            }
        });
    }

    fullReimbursement() {
        this.fullReimbursementActive = true;
        this.onFullReimbursement.next({
            contract: this.contract,
            data: this.fullReimbursementData,
            exchangeRate: this.finalExchangeRate
        });
    }

    downloadProforma() {
        this.isProcessing = true;
        this._earlyRepayment.downloadProforma({proforma_id: this.contract.proforma_invoices[0].proforma_invoice_id}).subscribe((response: any) => {
            this._proformaDownload.downloadFile(response, 'default.pdf');

            this.isProcessing = false;
        })
    }

    goToHistory() {
        this.onHistoryTab.next({});
    }
}
